import React, { Component } from "react";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";

import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import { func, shape, bool, string, arrayOf } from "prop-types";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";
import { connect } from "react-redux";
import I18n from "./I18n";
import ViewTitle from "./header/components/ViewTitle";
import Button from "pages/_components/Button";

import PageLoading from "pages/_components/PageLoading";
import ReactFilePreviewer from "react-file-previewer";

import { TERMS_AND_CONDITIONS_CATEGORY_PF } from "../../util/onboarding";

const CATEGORY = "termsAndConditions";

class TermsAndConditions extends Component {
    static propTypes = {
        isMobile: bool.isRequired,
        history: shape({ goBack: func }),
        fromOnboarding: bool,
        termsAndConditions: string,
        contentTermsAndConditions: string,
        isFetching: bool,
        documents: arrayOf(shape({})),
    };

    componentDidMount = () => {
        const { dispatch } = this.props;
        dispatch(settingsActions.getTermsAndConditions(CATEGORY));
        dispatch(settingsActions.loadDocumentsRequest(CATEGORY));
    };

    static defaultProps = {
        history: null,
        fromOnboarding: false,
        termsAndConditions: "",
        contentTermsAndConditions: "",
        isFetching: false,
    };

    backButtonAction = () => {
        const { history } = this.props;
        history.goBack();
    };

    handleClick = () => {
        const { dispatch, activeEnvironment, documents } = this.props;

        dispatch(settingsActions.downloadDocumentRequestWithIdEnv(documents[0]?.fileNameKey, TERMS_AND_CONDITIONS_CATEGORY_PF, activeEnvironment));
    };

    render() {
        const { isMobile, fromOnboarding, termsAndConditions, contentTermsAndConditions, isFetching } = this.props;

        return (
            <>
                <PageLoading loading={isFetching}>
                    {isMobile && (
                        <Head title="global.termAndConditions" onClose={!fromOnboarding && this.backButtonAction} />
                    )}
                    <MainContainer>
                        {!isMobile && (
                            <Container>
                                <Col xs={12} md={fromOnboarding ? 8 : 12} mdOffset={fromOnboarding ? 2 : 0}>

                                    <Head
                                        title="global.termAndConditions"
                                        onClose={!fromOnboarding && this.backButtonAction}
                                    />
                                    <ViewTitle id="global.termAndConditions" />

                                </Col>
                            </Container>
                        )}
                        <Row>
                            <Col xs={12} md={fromOnboarding ? 8 : 12} mdOffset={fromOnboarding ? 2 : 0}>
                                <div className="above-the-fold login-desktop-wrapper">
                                    {fromOnboarding && termsAndConditions && <I18n defaultValue={termsAndConditions} />}
                                    {!fromOnboarding && contentTermsAndConditions && (
                                        <>
                                            <Button
                                                image="images/figma/icon/download.svg"
                                                bsStyle="link"
                                                label="global.download"
                                                onClick={() => this.handleClick()}
                                            />
                                            <ReactFilePreviewer
                                                file={{
                                                    data: contentTermsAndConditions,
                                                    mimeType: "application/pdf",
                                                    name: "Términos y Condiciones.pdf", // for download
                                                }}
                                                hideControls={true}
                                            />
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    termsAndConditions: settingsSelectors.getTermsAndConditions(state),
    contentTermsAndConditions: settingsSelectors.getContentTermsAndConditions(state),
    isFetching: settingsSelectors.isFetching(state),
    documents: settingsSelectors.getDocuments(state),
});

export default connect(mapStateToProps)(TermsAndConditions);
